import { paymentAmountType } from "constants/common";
import classes from "./PayByText.module.scss";
import { renderConditionalProp } from "utility";
import { UseInput } from "hooks";

interface AmountSectionProps {
  paymentAmountTypeInput: UseInput;
  paymentAmount: UseInput;
  t: (key: string, options?: any) => string;
  isEnabled: boolean;
  minPaymentAmount?: number;
  maxPaymentAmount?: number;
}

export const AmountSection = ({
  paymentAmountTypeInput,
  paymentAmount,
  t,
  isEnabled,
  minPaymentAmount,
  maxPaymentAmount,
}: AmountSectionProps) => (
  <div className={classes.SectionWrapper}>
    <p className={classes.Heading}>{t("payment_final:payment_amount")}</p>
    <ft-formfield label={`${t("common:amount_due")}`}>
      <ft-radio
        id="amount-due-radio"
        {...renderConditionalProp(
          +paymentAmountTypeInput.value === paymentAmountType.due_amount,
          "checked"
        )}
        name="amount-type"
        value={paymentAmountType.due_amount}
        {...renderConditionalProp(!isEnabled, "disabled")}
        onClick={() =>
          paymentAmountTypeInput.setValue(paymentAmountType.due_amount)
        }
      ></ft-radio>
    </ft-formfield>
    <ft-formfield label={`${t("payment_next:other_amount")} $:`}>
      <ft-radio
        id="other-amount-radio"
        {...renderConditionalProp(
          +paymentAmountTypeInput.value === paymentAmountType.other,
          "checked"
        )}
        name="amount-type"
        value={paymentAmountType.other}
        {...renderConditionalProp(!isEnabled, "disabled")}
        onClick={paymentAmountTypeInput.valueChangeHandler}
      ></ft-radio>
    </ft-formfield>
    <ft-textfield
      class={classes.PaymentAmount_amount}
      outlined
      label={t("payment:amount")}
      customInput="test"
      type={"number"}
      step={".01"}
      ref={paymentAmount.ref}
      value={paymentAmount.value}
      required={+paymentAmountTypeInput.value === paymentAmountType.other}
      {...renderConditionalProp(
        +paymentAmountTypeInput.value === paymentAmountType.other,
        "required"
      )}
      icon="attach_money"
      {...renderConditionalProp(
        !isEnabled ||
          +paymentAmountTypeInput.value === paymentAmountType.due_amount,
        "disabled"
      )}
      min={minPaymentAmount}
      max={maxPaymentAmount}
      validationMessage={t("payment_next:greater_than_zero", {
        min: minPaymentAmount,
        max: maxPaymentAmount,
      })}
      onWheel={(e: WheelEvent) =>
        e.target instanceof HTMLElement && e.target.blur()
      }
      onInput={paymentAmount.decimalValueHandler}
    ></ft-textfield>
  </div>
);
